var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canRender)?_c('mds-layout-grid',[_c('filter-section'),_c('table-section')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }